import Component from '@glimmer/component'
import convertDateFormat from 'teacher-ui-client/utils/giraffe/convert-date-format'
import type Highcharts from 'highcharts'
import { SeriesLine } from 'teacher-ui-client/components/giraffe/primitives/series-line'
import { LeftSplitChart } from 'teacher-ui-client/components/giraffe/left-split-chart'
import { SummaryBox, type Stat } from 'teacher-ui-client/components/giraffe/summary-box'
import { array } from '@ember/helper'
import { SummaryBoxColorScheme } from 'teacher-ui-client/components/giraffe/summary-box/themes'
import { colors } from '@colors'
import type { Point } from 'highcharts'
import type { StorylandsStudentData } from 'teacher-ui-client/utils/student-events/fetchers/storylands-student'

function xAxisLabelFormatter(this: Highcharts.AxisLabelsFormatterContextObject) {
  return convertDateFormat(this.value as string)
}

function yAxisLabelFormatter(this: Highcharts.AxisLabelsFormatterContextObject) {
  const suffix = this.isLast ? '%' : ''
  return `${this.value}${suffix}`
}

function toolTipFormatter(this: Highcharts.Point) {
  const { monthData } = this as Point & { monthData: MonthData }
  const { average_score: score, attempts } = monthData

  return `
    Average Score: ${score}%</br>
    Attempts: ${attempts}
  `
}

interface MonthData {
  average_score: number
  attempts: number
  month: string
}

interface Args {
  summaryTitle: string
  data: StorylandsStudentData
}

interface Signature {
  Args: Args
}

export class StorylandsLessonsStudent extends Component<Signature> {
  get summary() {
    return this.args.data.summary.total_count
  }

  get monthsData() {
    return this.args.data.months
  }

  get categories() {
    return this.monthsData.map((monthData) => monthData.month)
  }

  get columns(): Highcharts.SeriesLineOptions[] {
    const data = this.monthsData.map((monthData, index) => {
      return { x: index, y: monthData.average_score, monthData }
    })

    return [{ name: 'average_score', data, color: colors.juicyOrange300, type: 'line' }]
  }

  get summaryStats(): Stat[] {
    return [{ label: 'Lessons completed', value: String(this.summary) }]
  }

  <template>
    <div class="h-full">
      <LeftSplitChart>
        <:left>
          <SummaryBox
            class="h-full"
            @title={{@summaryTitle}}
            @stats={{this.summaryStats}}
            @colorScheme={{SummaryBoxColorScheme.Orange}}
          />
        </:left>
        <:right>
          <SeriesLine
            @data={{this.columns}}
            @categories={{this.categories}}
            @xAxisLabelFormatter={{xAxisLabelFormatter}}
            @toolTipFormatter={{toolTipFormatter}}
            @title="Storylands progress"
            @yAxisLabel="Score"
            @yRange={{array 0 100}}
            @yAxisLabelFormatter={{yAxisLabelFormatter}}
          />
        </:right>
      </LeftSplitChart>
    </div>
  </template>
}

export default StorylandsLessonsStudent
